import Cookies from 'js-cookie'

const TokenKey = 'token'
const SubSiteKey = 'CurSubSiteId'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getSubSiteId() {
  const id = Cookies.get(SubSiteKey)
  return id === undefined || id === '' ? 0 : Number(id)
}

export function setSubSiteId(id) {
  return Cookies.set(SubSiteKey, String(id))
}
